import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Layout from "layouts/DashboardManage";
import { updatePassword } from "store/actions/userAction";
import hasProperty from "lodash/has";
import { notifyApiError } from "components/Notification";
import SubmitButton from "components/Forms/Buttons/Submit";
import Textbox from "components/Forms/Elements/Textbox";
import { SpinnerSyncBlock } from "components/Spinner";
import Translate from "helpers/Translate";

export class ChangePassword extends Component {
  state = {
    password: "",
    password_confirmation: "",
    user: this.props.match.params.userId
  };

  componentDidUpdate(prevProps) {
    // When the new user is created successfully, we will redirect to step 2
    if (
      prevProps.updateUserResponse !== this.props.updateUserResponse &&
      hasProperty(this, "props.updateUserResponse.id")
    ) {
      // Redirect to manage page
      return this.props.history.push(`/manage/users`);
    }

    // When there was a problem updating the password
    if (
      prevProps.errorUser !== this.props.errorUser &&
      this.props.errorUser &&
      Object.keys(this.props.errorUser).length > 0
    ) {
      notifyApiError(this.props.errorUser);
    }
  }

  handleChange = e => {
    const target = e.target;
    this.setState(() => ({
      [target.name]: target.value.trim()
    }));
  };

  handleUpdate = () => {
    this.props.updatePassword(this.state);
  };

  render() {
    return (
      <Layout>
        {this.props.isLoading && <SpinnerSyncBlock />}
        <div className="add-edit">
          <h1 className="title mb-30">
            {Translate({ id: "change_user_password" })}{" "}
          </h1>

          <div className="center-form">
            <div className="form-wrapper mb-20">
              <div className="form-group mb-10">
                <label htmlFor="password">
                  * {Translate({ id: "new_password" })} :
                </label>
                <Textbox
                  type="password"
                  id="password"
                  name="password"
                  fieldValue={this.state.password}
                  onChange={this.handleChange}
                  onReturnKey={this.handleUpdate}
                  errors={this.props.errorUser}
                  errorKey="password"
                  formErrorClass="form-error"
                />
              </div>
              <div className="form-group mb-10">
                <label htmlFor="password_confirmation">
                  * {Translate({ id: "confirm_password" })} :
                </label>
                <Textbox
                  type="password"
                  id="password_confirmation"
                  name="password_confirmation"
                  fieldValue={this.state.password_confirmation}
                  onChange={this.handleChange}
                  onReturnKey={this.handleUpdate}
                  errors={this.props.errorUser}
                  errorKey="password_confirmation"
                  formErrorClass="form-error"
                />
              </div>
            </div>
          </div>

          <div className="save-cancel-buttons">
            <Link
              to={`/manage/users`}
              className="btn manage-btn-cancel"
            >
              <i className="far fa-times-circle mr-10"></i> {Translate({ id: "cancel" })}
            </Link>

            <SubmitButton
              className="btn btn-primary manage-btn-save"
              buttonIconClass="fas fa-save mr-10"
              buttonText={Translate({ id: "save_changes" })}
              btnId="create"
              isLoading={this.props.isLoading}
              handleSubmit={this.handleUpdate}
            />
          </div>
        </div>
      </Layout>
    );
  }
}

ChangePassword.propTypes = {
  updatePassword: PropTypes.func.isRequired,
  updateUserResponse: PropTypes.object,
  errorUser: PropTypes.object,
  isLoading: PropTypes.bool
};

const mapStateToProps = state => {
  return {
    updateUserResponse: state.user.updateUserPassword,
    errorUser: state.user.errorUser,
    isLoading: state.user.isLoadingUser || state.role.isLoadingRole
  };
};

export default connect(mapStateToProps, { updatePassword })(ChangePassword);
